import React from "react";
import { Seo, Section, SectionHead, FadeUp } from "./Ui";
import { WHY } from "./data";

export default function DrezoroAbout() {
  return (
    <div data-testid="drezoro-about">
      <Seo title="About — DREZORO" description="DREZORO is the parent technology company and innovation group behind Vozelto, TurnKey, Black Ember Coffee, and Operation Enough." />
      <Section>
        <SectionHead label="About DREZORO" title="The parent technology company behind the brands."
          intro="DREZORO is an innovation group that creates, owns, and advances AI platforms and technology businesses. We are builders first — every company in our portfolio began as an idea engineered into a working business." />
        <div className="grid md:grid-cols-3 gap-6 mb-20">
          {[
            ["What we do", "We develop intelligent software, AI systems, automation platforms, and modern technology businesses — then operate them with enterprise discipline."],
            ["How we work", "Long-term thinking over short-term wins. Shared technology across the group. Relentless focus on reliability and measurable customer outcomes."],
            ["Where we're going", "Toward a portfolio of intelligent companies — each one proving that AI-first operations create durable advantages for the businesses they serve."],
          ].map(([t, d], i) => (
            <FadeUp key={t} delay={i * 0.08}>
              <div className="dz-card p-7 h-full">
                <div className="w-8 h-px bg-blue-500 mb-5" aria-hidden="true" />
                <h3 className="text-base font-medium text-white">{t}</h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{d}</p>
              </div>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="relative overflow-hidden dz-card p-10 md:p-16 text-center">
          <div className="absolute inset-0 flex justify-center" aria-hidden="true"><div className="w-96 h-96 rounded-full bg-blue-500/[0.08] blur-[100px]" /></div>
          <div className="relative">
            <div className="dz-label mb-5">Our Vision</div>
            <blockquote className="text-xl sm:text-2xl lg:text-3xl font-light tracking-tight leading-snug max-w-3xl mx-auto">
              "Our vision is to build intelligent technology that empowers businesses of every size to accomplish more with less effort."
            </blockquote>
          </div>
        </FadeUp>
      </Section>
      <Section className="border-t border-white/5 !pt-0">
        <SectionHead label="Principles" title="What we hold ourselves to." />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {WHY.map((w, i) => (
            <FadeUp key={w.t} delay={i * 0.04}>
              <div className="border-t border-white/15 pt-5">
                <h3 className="text-base font-medium text-white">{w.t}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{w.d}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </Section>
    </div>
  );
}
